module.exports = __webpack_public_path__ + "img/yingyouMa.62948842.jpg";